var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nibnut-editor",class:( _obj = {}, _obj[("nibnut-editor-" + _vm.size)] = true, _obj ),attrs:{"id":_vm.id}},[_c('vue-trix',{ref:"editor",attrs:{"value":_vm.value,"input-name":_vm.name,"placeholder":_vm.placeholder,"disabled-editor":!_vm.editable},on:{"trix-initialize":_vm.initialize,"input":_vm.debounced_emit_input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }